import { render, staticRenderFns } from "./AlarmData.vue?vue&type=template&id=4b793caa&scoped=true&"
import script from "./AlarmData.vue?vue&type=script&lang=js&"
export * from "./AlarmData.vue?vue&type=script&lang=js&"
import style0 from "./AlarmData.vue?vue&type=style&index=0&id=4b793caa&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b793caa",
  null
  
)

export default component.exports